import { LineLengthList } from "."

export const getEffectIndex = (
  lineIndex: number,
  itemIndex: number
): number => {
  let index = 0

  for (let i = 0; i < lineIndex; i++) {
    index += LineLengthList[i % LineLengthList.length]
  }

  return index + itemIndex
}
